import type { InventoryItemKind } from '../inventory-item-list-types.js';

// WHY: "Type" is a display-only label over InventoryItemKind -- the enum itself stays FINISHED_GOOD/COMPONENT everywhere else.
export const INVENTORY_ITEM_KIND_LABELS: Record<InventoryItemKind, string> = {
  FINISHED_GOOD: 'Products',
  COMPONENT: 'Parts',
};
